module.exports = __webpack_public_path__ + "static/media/anger-and-depression.b0151226.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/anger-and-depression.jpg
// module id = 246
// module chunks = 0